import React from "react";
import { Box, Paper, Typography, Button, Stack } from "@mui/material";
import { Explore as ExploreIcon } from "@mui/icons-material";

export default function Quick() {
  const gradientStyle = {
    background:
      "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #454545 100%)",
  };

  return (
    <Paper
      sx={{
        p: 6,
        borderRadius: 0,
        ...gradientStyle,
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 -10px 40px rgba(0,0,0,0.3)",
      }}
      id="quick"
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "100%",
          height: "100%",
          background:
            "radial-gradient(circle at top right, rgba(76,175,80,0.1) 0%, transparent 50%), radial-gradient(circle at bottom left, rgba(33,150,243,0.1) 0%, transparent 50%)",
          animation: "pulse 4s ease-in-out infinite",
        }}
      />

      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Typography variant="h4" sx={{ color: "#d6d6d6" }} fontWeight={700}>
          Ready to Start Monitoring?
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 4, opacity: 0.9, maxWidth: 600, mx: "auto" }}
        >
          Join the fight for wildlife conservation with our advanced monitoring
          system
        </Typography>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
        >
          <Button
            variant="contained"
            size="large"
            startIcon={<ExploreIcon />}
            sx={{
              background:
                "linear-gradient(135deg, #454545 0%, rgba(129, 129, 129, 0.95) 100%)",
              px: 5,
              py: 1.5,
              borderRadius: 3,
              fontWeight: 700,
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 12px 40px rgba(76,175,80,0.4)",
              },
              transition: "all 0.3s ease",
            }}
            href="/dashboard"
          >
            View Dashboard
          </Button>
          <Button
            variant="outlined"
            size="large"
            sx={{
              borderColor: "rgba(255,255,255,0.3)",
              color: "white",
              px: 5,
              py: 1.5,
              borderRadius: 3,
              "&:hover": {
                borderColor: "white",
                bgcolor: "rgba(255,255,255,0.1)",
                transform: "translateY(-4px)",
              },
              transition: "all 0.3s ease",
            }}
            href="/cameras"
          >
            Browse Cameras
          </Button>
        </Stack>
      </Box>
    </Paper>
  );
}
